import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

interface SharedLinkLandingPageStylesClasses {
  sharedLinkPage: string;
  sharedLinkContentContainer: string;
  gridItems: string;
}

const styles = makeStyles<Theme, object, keyof SharedLinkLandingPageStylesClasses>((theme) => ({
  sharedLinkPage: {
    backgroundColor: theme.palette.background.default,
    width: '100%',
    minHeight: '100vh',
  },
  // Plain block wrapper — do NOT set display:flex here. The shared link content renders a
  // TopNavBar + page as sibling React elements, and a flex parent would turn them into
  // horizontal columns (each demanding width:100% collapses to ~50%). The password form
  // handles its own centering via SharedLinkContentStyles.formContainer.
  sharedLinkContentContainer: {
    width: '100%',
  },
  gridItems: {
    margin: '1rem',
    position: 'relative',
  },
}));

export default styles;
